/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ActiveTasksResponse = {
    type: 'dictionary',
    contains: {
        type: 'array',
        contains: {
            type: 'ActiveTask',
        },
    },
} as const;
